// extracted by mini-css-extract-plugin
module.exports = {"chip":"chip-oNDf9","active":"active-hnUWc"};